export function relativeDateAndTime(unixTimestamp: number, compact?: boolean): string {
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    const diffInSeconds = now - unixTimestamp;
    const c = compact ?? false

    if (diffInSeconds < 60) {
        return `${diffInSeconds}${c ? "s": (" second" + (diffInSeconds === 1 ? "" : "s"))} ago`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return `${diffInMinutes}${c ? "min": (" minute" + (diffInMinutes === 1 ? "" : "s"))} ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `${diffInHours}${c ? "h": (" hour" + (diffInHours === 1 ? "" : "s"))} ago`;
    }

    // If more than 24 hours old, return a formatted date
    const date = new Date(unixTimestamp * 1000);
    return date.toLocaleString(); // Displays date in the user's locale format
}

export function relativeDate(unixTimestamp: number, compact?: boolean, forceDays?: boolean, appendAt?: boolean): string {
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    const diffInSeconds = unixTimestamp - now;
    const c = compact ?? false;

    if (Math.abs(diffInSeconds) < 60) {
        return `${diffInSeconds < 0 ? Math.abs(diffInSeconds) + (c ? "s" : (" second" + (Math.abs(diffInSeconds) === 1 ? "" : "s"))) + " ago" : "in " + Math.abs(diffInSeconds) + (c ? "s" : (" second" + (Math.abs(diffInSeconds) === 1 ? "" : "s")))}`;
    }

    const diffInMinutes = Math.floor(Math.abs(diffInSeconds) / 60);
    if (diffInMinutes < 60) {
        return `${diffInSeconds < 0 ? Math.abs(diffInMinutes) + (c ? "min" : (" minute" + (diffInMinutes === 1 ? "" : "s"))) + " ago" : "in " + Math.abs(diffInMinutes) + (c ? "min" : (" minute" + (diffInMinutes === 1 ? "" : "s")))}`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `${diffInSeconds < 0 ? Math.abs(diffInHours) + (c ? "h" : (" hour" + (diffInHours === 1 ? "" : "s"))) + " ago" : "in " + Math.abs(diffInHours) + (c ? "h" : (" hour" + (diffInHours === 1 ? "" : "s")))}`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (forceDays === true || diffInDays < 7) {
        return `${diffInSeconds < 0 ? Math.abs(diffInDays) + (c ? "d" : (" day" + (diffInDays === 1 ? "" : "s"))) + " ago" : "in " + Math.abs(diffInDays) + (c ? "d" : (" day" + (diffInDays === 1 ? "" : "s")))}`;
    }

    // If more than 7 days, return a formatted date
    const date = new Date(unixTimestamp * 1000);
    return (appendAt ? "at " : "") + date.toLocaleDateString(); // Displays date in the user's locale format
}

export function relativeDuration(seconds: number, hideSeconds?: boolean): string {
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    let result = "";
    if (days > 0) result += `${days}d `;
    if (hours > 0) result += `${hours}h `;
    if (minutes > 0) result += `${minutes}min `;
    if ((!hideSeconds && seconds > 0) || result === "") result += `${seconds}s`;

    return result.trim();
}

